import {assertUnreachable} from '@wandb/weave/common/util/types';
import React from 'react';
import {Redirect, useParams, useRouteMatch} from 'react-router';

import {HomePageWrapper} from '../../pages/HomePage/HomePageWithData';
import {useViewer} from '../../state/viewer/hooks';
import RegistriesContent from './RegistriesContent';
import {determineRegistryAction} from './registryUrls';

type RegistriesParams = {
  orgName?: string;
  entityName?: string;
  registryName?: string;
};

const RegistriesRouter = () => {
  const viewer = useViewer();
  const {path} = useRouteMatch();
  const {orgName, entityName, registryName} = useParams<RegistriesParams>();

  if (viewer == null || !viewer?.username) {
    {
      /*TODO: Anon view for global registry - will vary for server vs public cloud*/
    }
    const search = window.location.search;
    const registryAction = determineRegistryAction(
      false,
      false,
      orgName,
      '',
      entityName,
      registryName,
      path,
      search,
      [],
      true,
      false
    );

    switch (registryAction.type) {
      case 'redirect':
        return <Redirect to={registryAction.to} />;
      case 'load':
        return <RegistriesContent {...registryAction} />;
      default:
        return assertUnreachable(registryAction);
    }
  }

  // Go to our home page to handle displaying the sidebar with registry content.
  // We want this view when user is logged in.
  return <HomePageWrapper />;
};

export default RegistriesRouter;
